import { render, staticRenderFns } from "./PhotoSmall.vue?vue&type=template&id=7b8cbddb&scoped=true"
import script from "./PhotoSmall.vue?vue&type=script&lang=js"
export * from "./PhotoSmall.vue?vue&type=script&lang=js"
import style0 from "./PhotoSmall.vue?vue&type=style&index=0&id=7b8cbddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cbddb",
  null
  
)

export default component.exports